<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="PDM环节延期责任榜 right_6"
      :rightTitle="`${formatTime(date, 'yyyy年MM月')} 合计：${totalNum}`"
      :tooltipText="'各环节实时延期订单数量'"
      ><el-button
        type="primary"
        slot="detail"
        size="mini"
        style="margin-left: 10px"
        @click="handleDetail"
        >详 情</el-button
      ></chart-title
    >
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
      <div id="right_6" slot="main" />
    </date-change-card>
  </div>
</template>

<script>
import { getTransferDelay } from "@/api/cockpit/vrhouse";
import { delayContract } from "@/api/cockpit/sp";
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";

import {
  formatTime,
  getNextMonth,
  getFirstDate,
  arrDataFormat,
  arrDistinct,
} from "@/utils/index";
export default {
  mixins: [resize],
  name: "right_6",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      chart: null,
      date: new Date(),
      chartData: "",
      totalNum: 0,
      showData: {
        '转单': 0, '商家确认': 0, '财务': 0, '流程卡': 0, '采购': 0, '排产确认': 0, '生产': 0
      },
      amountArr: []
    };
  },
  props: {},
  created() {},
  mounted() {
    this.getData();
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    formatTime,
    //获取数据
    async getData() {

      this.amountArr = []; //初始化

      //获取虚拟家数据
      await getTransferDelay(
          {'month':getFirstDate(this.date, "yyyy-MM-dd")}
      ).then((resp) => {
        this.amountArr.push(...resp.data.list);        //转单
        this.showData.转单 = resp.data.list.length;   //获取转单延期数量
      });

      //获取PER数据
      await delayContract(
          {'dayTime':getFirstDate(this.date, "yyyy-MM-dd")}
      ).then((resp) => {

        console.log(resp.data)
        //处理合计数据
        this.amountArr.push(...resp.data.sj_delay_orders);   //商家确认
        this.amountArr.push(...resp.data.lck_delay_orders);  //流程卡
        this.amountArr.push(...resp.data.qwl_delay_orders);  //采购
        this.amountArr.push(...resp.data.wqr_delay_orders);  //排产确认
        this.amountArr.push(...resp.data.yq_delay_orders);   //生产

        //赋值各项延期数据
        this.showData.商家确认 = resp.data.sj_delay_orders.length;   //商家确认
        this.showData.财务 = 0;                                     //财务
        this.showData.流程卡 = resp.data.lck_delay_orders.length;   //流程卡
        this.showData.采购 = resp.data.qwl_delay_orders.length;     //采购
        this.showData.排产确认 = resp.data.wqr_delay_orders.length;  //排产确认
        this.showData.生产 = resp.data.yq_delay_orders.length;      //生产
      });


      this.chartData = arrDataFormat(this.showData);
      this.totalNum = arrDistinct(this.amountArr).length; //合计数据
      this.initChart();
    },
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("right_6"));
      this.setOptions();
    },
    setOptions() {
      const color = [
        "#1158a7",
        "#0983ff",
        "#59abf6",
        "#abd6fc",
        "#29beb9",
        "#3bffd0",
        "#22e4ff",
        "#40E0D0",
      ];
      const valArr = this.chartData.map((m) => m.value);
      const maxVal = Math.max(...valArr);
      this.chart.setOption({
        polar: {
          radius: [30, "80%"],
        },
        radiusAxis: {
          max: maxVal + 20,
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: "#606266",
            },
          },
        },
        angleAxis: {
          type: "category",
          data: this.chartData.map((m) => m.name),
          startAngle: 75,
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          axisLabel: {
            color: "#C0C4CC",
          },
        },

        tooltip: {},
        series: {
          type: "bar",
          data: this.chartData.map((m, index) => {
            return {
              value: m.value,
              itemStyle: {
                color: color[index],
              },
              label: {
                color: "#ffffff",
              },
            };
          }),
          coordinateSystem: "polar",
          label: {
            show: true,
            position: "inside",
            formatter: "{c}",
          },
        },
      });
      this.chart.on("click", function (params) {
        console.log(params);
        if (params.name == "转单") {
          window.open(
            `${process.env.VUE_APP_VRHOUSE_URL}/api/cockpit/transfer_delay_detail?username=${process.env.VUE_APP_NAME_PDM}&password=${process.env.VUE_APP_PASS}`,
            "_blank"
          );
        } else if (params.name == "采购") {
          window.open(
            `${process.env.VUE_APP_JYL_URL}/#/login?nameJSC=采购延期统计&username=${process.env.VUE_APP_NAME_SCM}&password=${process.env.VUE_APP_PASS}`,
            "_blank"
          );
        } else if (params.name == "生产") {
          window.open(
            `${process.env.VUE_APP_JYL_URL}/#/login?nameJSC=生产延期统计&username=${process.env.VUE_APP_NAME_MES}&password=${process.env.VUE_APP_PASS}`,
            "_blank"
          );
        }
      });
    },

    //前一月
    leftClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), -1);
      this.getData();
    },
    //后一月
    rightClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), +1);
      this.getData();
    },
    handleDetail() {
      window.open(
        `${process.env.VUE_APP_JYL_URL}/#/login?nameJSC=延期订单统计&username=${process.env.VUE_APP_NAME_MES}&password=${process.env.VUE_APP_PASS}`,
        "_blank"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 35vh;
  #right_6 {
    height: 100%;
  }
}
</style>
